import { React } from "react";
import dayjs from "dayjs";

// Hooks
import useNotify from "../../hooks/notify";

//CSS
import useStyles from "./styles";

//Components
import Searchbox from "../../components/inputs/searchbox";
import WrapperDatePicker from "../../components/wrapperDatapicker";
import WrapperTimePicker from "../../components/wrapperTimepicker";
import Input from "../../components/inputs/input";

//Material UI
import { Paper, Button, Typography, Grid } from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';

const FORMAT_DATE = 'YYYY-MM-DD'

const Filters = ({ filters, setFilters, clearFilters }) => {
  const { classes } = useStyles();
  const { Notify, variants } = useNotify();
  const handleInputChange = (event) =>
    setFilters({ ...filters, [event.target.name]: event.target.value, pageNumber: 1 });

  const handleDateChange = (event) => {
    const name = event.target.name;
    const timeName = name === "startDate" ? "startTime" : "endTime";
    setFilters(state => {
      const newState = { 
        ...state, 
        [name]: event.target.value,
        // Solo limpiar el tiempo si el evento viene de un input manual
        ...(event.target.type === 'date' ? { [timeName]: null } : {}),
        pageNumber: 1
      }

      const isValid = validateDateRange(newState.startDate, newState.endDate);
      
      if (!isValid) {
        return state; // Si no es válido, mantener el estado anterior
      }

      return newState;
    });
  };

  const validateDateRange = (startDate, endDate) => {
    if (!startDate || !endDate) return true;

    const start = dayjs(startDate);
    const end = dayjs(endDate);
    const diff = end.diff(start, 'days');

    if (diff < 0) {
      Notify('La fecha final no puede ser menor a la fecha inicial', variants.ERROR);
      return false;
    }

    if (diff > 7) {
      Notify('El rango no puede ser mayor a 7 días', variants.ERROR);
      return false;
    }

    return true;
  };

  const getStartDateConstraints = () => {
    if (!filters?.endDate) {
      return {
        minDate: dayjs().subtract(7, 'days'),
        maxDate: dayjs()
      };
    }

    const endDate = dayjs(filters.endDate);
    return {
      minDate: endDate.subtract(7, 'days'),
      maxDate: endDate
    };
  };

  const getEndDateConstraints = () => {
    if (!filters?.startDate) {
      return {
        minDate: dayjs().subtract(7, 'days'),
        maxDate: dayjs()
      };
    }

    const startDate = dayjs(filters.startDate);
    return {
      minDate: startDate,
      maxDate: startDate.add(7, 'days')
    };
  };

  const handleSkuChange = (event) => {
    const refId = event.target.value
      .toUpperCase()
      .replace(/\s/g, '')
      .split(",");

    setFilters({ ...filters, refId, pageNumber: 1 });
  };

  return (
    <Paper className={classes.paper}>
      <Grid container spacing={1}>
        <Grid
          container
          spacing={1}
          size={{
            md: 12
          }}
        >

          <Grid size={12}>
            <Typography variant="inherit" color="primary">
              {" "}
              Filtrar por producto{" "}
            </Typography>
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 6
            }}
          >
            <Searchbox
              fullWidth
              size="small"
              name="refId"
              label="Skus"
              placeholder="Ej.: 10034K12024%A, 10034K12029%R"
              helperText="Skus separados por comas"
              onChange={handleSkuChange}
              className={classes.searchbox}
              value={filters?.refId || ""}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 6
            }}
          >
            <Searchbox
              fullWidth
              size="small"
              name="shortDescription"
              label="Descripción"
              helperText="Descripción corta del producto"
              onChange={handleInputChange}
              className={classes.searchbox}
              value={filters?.shortDescription || ""}
            />
          </Grid>
          <Grid size={6}>
            <Typography variant="inherit" color="primary">
              Filtrar por fecha
            </Typography>
          </Grid>
          <Grid size={6}>
            <Typography variant="inherit" color="primary">
              Filtrar por hora
            </Typography>
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 4,
              md: 3
            }}
          >
            <WrapperDatePicker
              filters={filters?.startDate}
              handleFilterChange={handleDateChange}
              type="startDate"
              inputProps={{
                ...getStartDateConstraints(),
                fullWidth: true,
                size: "small"
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 4,
              md: 3
            }}
          >
            <WrapperDatePicker
              filters={filters?.endDate}
              handleFilterChange={handleDateChange}
              type="endDate"
              inputProps={{
                ...getEndDateConstraints(),
                fullWidth: true,
                size: "small"
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 4,
              md: 2
            }}
          >
            <WrapperTimePicker
              filters={filters?.startTime}
              handleFilterChange={handleInputChange}
              type="startTime"
              inputProps={{
                disabled: !filters?.startDate,
                fullWidth: true,
                size: "small"
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 4,
              md: 2
            }}
          >
            <WrapperTimePicker
              filters={filters?.endTime}
              handleFilterChange={handleInputChange}
              type="endTime"
              inputProps={{
                disabled: !filters?.endDate,
                fullWidth: true,
                size: "small"
              }}
            />
          </Grid>
          <Grid
            container
            spacing={1}
            className={classes.fabButtons}
            alignContent="flex-end"
            size={{
              md: 2
            }}
          >
            <Button
              color="primary"
              variant="outlined"
              onClick={clearFilters}
              className={classes.button}
              startIcon={<FilterListIcon />}
            >
              Limpiar
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Filters;
